
import { useStore } from '@/store'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'GreenboardOption',
  props: {
    optionHeader: String,
    optionValue: {
      type: String,
      default: null
    },
    smallLatterSpacing: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const store = useStore()
    const isBagLoaded = computed(() => store.getters.isBagLoaded)
    const isThreeMode = computed(() => store.getters.isThreeMode)
    
    const formatOption = (str: string | null) => {
      if(isThreeMode.value && !isBagLoaded.value) {
        return '&nbsp;'
      }
      return !str || 0 === str.length ? '未選択' : str
    }

    return {
      isBagLoaded,
      formatOption
    }
  }
})
